import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const DockLocation = ({ situation }: SpecProps<"situation">) => {
  const { i18n } = useLingui();
  if (!situation) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.dockLocation",
    message: "Location",
    comment: "Field for 'dock location' in ad specification",
  });
  return <FieldValuePair field={field} value={situation} />;
};
